import { AdminAfpantPage } from "@/components/AdminAfpantPage/AdminAfpantPage";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
import { formatOrganisationNumber } from "@terralux/common/string";

export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/")({
  loader: async ({ params }) => {
    const { orgNumber } = params;

    const res = await routeLoaderApiClient.superuser.organisation[":orgNumber"].$get({ param: { orgNumber } });

    if (res.ok === false) {
      throw new Error("Failed to fetch messages");
    }

    return {
      organisation: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Superuser AFPANT | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { organisation } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle subtitle={`${organisation.name} (${formatOrganisationNumber(organisation.orgNumber)})`}>
        Superuser AFPANT
      </DocumentTitle>

      <AdminAfpantPage organisation={organisation} />
    </>
  );
}
